
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import {PermissionManagerService} from "../services/permissionManager.seervice";
import {PermissionsFactory} from "../permissions.factory";
import {ModuleRolePermission} from "../models/moduleRolePermission";
import {PermissionBase} from "../permissionBase";
import {AccountService} from "../../services";

@Directive({
    selector: '[appHasRole]'
})
export class HasRoleDirective {
    private permissions: PermissionBase;
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private permissionManagerS: PermissionManagerService,
        private accountService: AccountService,
    ) { }

    @Input() set appHasRole(permission: string) {
        this.hasRole(permission);
    }
    private hasRole(permission: string) {
        if (this.accountService.hasRole(permission)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
